import { injectTranslate } from '@recruitee/i18n';
import { textCellFactory } from '@recruitee/user-interface';

import { defineOfferTableColumn } from './utils';
import { OfferColumnId } from '../../../offers-page/offers-table/offers.table-service';

export const jobGuidColumn = defineOfferTableColumn(() => ({
  id: OfferColumnId.JobGuid,
  label: injectTranslate()('app.offers.table.job_id'),
  visible: false,
  geometry: {
    width: 150,
    minWidth: 100,
    maxWidth: 200,
    autoFitProp: 'width',
  },
  options: {
    draggable: false,
    resizable: true,
    removable: true,
    sortable: false,
  },
  componentFactory: textCellFactory('guid'),
}));
